import { PageRoute } from "@quest-finance/quest-fe-shared/dist/common/types/PageRoute";
import Home from "../pages/Home/Home";

const routes: PageRoute[] = [
  {
    name: "Home Page",
    path: "/home",
    exact: true,
    component: Home,
  },
];

export default routes;
